import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
import { useHistory } from 'react-router-dom';
import Style from './MenuTitle.module.css'
const MenuTitle = (props) => {
    let history=useHistory()
    return (
        <div className={Style.ComponentHolder}>
            <h3>{props.title}</h3>
            <div  onClick={() => history.goBack()} className={Style.backIcon}><FontAwesomeIcon icon={faArrowRight} style={{fontSize:"1.2rem"}}/></div>
        </div>
    )
}
export default MenuTitle
